<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>单词卡</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="单词：">
              <Input v-model="queryParam.word" placeholder="支持模糊搜索" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="状态：">
              <Select v-model="queryParam.status" placeholder="全部" clearable>
                <Option :value="1">启用</Option>
                <Option :value="0">停用</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
            <Button type="primary" icon="plus" style="margin-left: 8px" @click="openModal()">新增</Button>
          </Col>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/wordCard/list"
          :params="queryParam" :onLoading="onLoading"></List>

    <Modal :title="formData.id ? '编辑单词卡' : '新增单词卡'" v-model="showModal" width="640" :mask-closable="false">
      <Form ref="editForm" :label-width="100" :model="formData" :rules="formRules">
        <FormItem label="单词" prop="word">
          <Input v-model="formData.word" placeholder="请输入单词" :disabled="!!formData.id"></Input>
        </FormItem>
        <FormItem label="英文释义" prop="enDef">
          <Input v-model="formData.enDef" type="textarea" :rows="3" placeholder="请输入英文释义"></Input>
        </FormItem>
        <FormItem label="例句" prop="exampleSentence">
          <Input v-model="formData.exampleSentence" type="textarea" :rows="3" placeholder="请输入例句"></Input>
        </FormItem>
        <FormItem label="例句音频" prop="exampleAudio">
          <FileUpload :defaultFileList="defaultFileList" :num="1" @on-file-change="onFileChange"
                      text="点击或拖拽上传音频"></FileUpload>
        </FormItem>
        <FormItem label="状态">
          <Select v-model="formData.status" style="width: 160px">
            <Option :value="1">启用</Option>
            <Option :value="0">停用</Option>
          </Select>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showModal = false">取消</Button>
        <Button type="primary" :loading="saveLoading" @click="onSave">保存</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchLoading: false,
      saveLoading: false,
      reload: 0,
      showModal: false,
      defaultFileList: [],
      queryParam: {
        word: '',
        status: null
      },
      formData: this.emptyForm(),
      formRules: {
        word: [{required: true, message: '请输入单词'}]
      },
      title: [
        {
          title: '单词',
          minWidth: 120,
          render: (h, params) => {
            let row = params.row
            return h('span', row.displayWord || row.word || '')
          }
        },
        {title: '英文释义', minWidth: 180, key: 'enDef'},
        {title: '例句', minWidth: 200, key: 'exampleSentence'},
        {
          title: '例句音频',
          minWidth: 200,
          render: (h, params) => {
            let url = params.row.exampleAudio
            if (!url) {
              return h('span', '')
            }
            return h('audio', {
              attrs: {src: url, controls: 'controls', preload: 'none'},
              style: {width: '180px', height: '32px'}
            })
          }
        },
        {
          title: '状态',
          width: 90,
          render: (h, params) => {
            let row = params.row
            if (row.statusText) {
              return h('span', row.statusText)
            }
            return h('span', row.status === 1 ? '启用' : '停用')
          }
        },
        {title: '修改时间', minWidth: 160, key: 'gmtModified'},
        {
          title: '操作',
          width: 160,
          render: (h, params) => {
            let row = params.row
            let btns = []
            if (row.status === 1 || row.statusText === '启用') {
              btns.push(h('Button', {
                props: {type: 'warning', size: 'small'},
                style: {marginRight: '6px'},
                on: {click: () => this.changeStatus(row, 0)}
              }, '停用'))
            } else {
              btns.push(h('Button', {
                props: {type: 'success', size: 'small'},
                style: {marginRight: '6px'},
                on: {click: () => this.changeStatus(row, 1)}
              }, '启用'))
            }
            btns.push(h('Button', {
              props: {type: 'primary', size: 'small'},
              on: {click: () => this.openModal(row)}
            }, '编辑'))
            return h('div', btns)
          }
        }
      ]
    }
  },
  methods: {
    emptyForm () {
      return {
        id: null,
        word: '',
        enDef: '',
        exampleSentence: '',
        exampleAudio: '',
        status: 1
      }
    },
    openModal (row) {
      if (row) {
        this.formData = {
          id: row.id,
          word: row.word || row.displayWord || '',
          enDef: row.enDef || '',
          exampleSentence: row.exampleSentence || '',
          exampleAudio: row.exampleAudio || '',
          status: row.status == null ? 1 : row.status
        }
        let url = row.exampleAudio
        this.defaultFileList = url ? [{name: row.exampleAudioName || url, url: url, status: 'finished'}] : []
      } else {
        this.formData = this.emptyForm()
        this.defaultFileList = []
      }
      this.showModal = true
    },
    onFileChange (files) {
      if (files && files.length) {
        this.formData.exampleAudio = files[0].url
      } else {
        this.formData.exampleAudio = ''
      }
    },
    onSave () {
      if (!this.formData.word) {
        this.$Message.warning('请输入单词')
        return
      }
      let self = this
      self.saveLoading = true
      self.$http.post('/wordCard/save', {}, {
        transformRequest: [function () {
          return JSON.stringify(self.formData)
        }],
        headers: {'Content-Type': 'application/json;charset=utf-8'}
      }).then(function (res) {
        self.saveLoading = false
        if (res.status === 'ok') {
          self.$Message.success('保存成功')
          self.showModal = false
          self.search()
        }
      }).catch(function () {
        self.saveLoading = false
      })
    },
    changeStatus (row, status) {
      let self = this
      self.$http.post('/wordCard/updateStatus', {id: row.id, status: status}).then(function (res) {
        if (res.status === 'ok') {
          self.$Message.success('操作成功')
          self.search()
        }
      })
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    }
  }
}
</script>



// WEBPACK FOOTER //
// WordCardList.vue?8ad5d4b6